import * as React from 'react';
import {
  withStyles,
  WithStyles,
  createStyles,
  Theme,
} from '@material-ui/core/styles';
import CalendarToday from '@material-ui/icons/CalendarToday';
import Typography from '@material-ui/core/Typography';

import { withIntl, IntlProps } from 'ha/i18n';
import MediaQuery from 'ha/helpers/MediaQuery';
import units from 'ha/theme/units';
import Row from 'ha/ui/next/Row';
import Col from 'ha/ui/next/Col';

const styles = (t: Theme) =>
  createStyles({
    wrapper: {
      [t.breakpoints.up('md')]: {
        margin: units.trbl(0.5, 0, 1, 0),
      },
      [t.breakpoints.down('sm')]: {
        margin: units.trbl(0.5, 0, 0.7, 0),
      },
    },
    container: {
      border: units.border(1, 'solid', t.palette.primary.main),
      borderRadius: units.rem(0.4),
      padding: units.rem(0.5),
    },
    iconContainer: {
      lineHeight: 1,
    },
    icon: {
      width: units.rem(2),
      height: units.rem(2),
    },
    textContainer: {
      flexGrow: 1,
      marginLeft: units.rem(0.5),
    },
  });

const SearchUrgencyCard: React.SFC<IntlProps & WithStyles<typeof styles>> = ({
  classes,
  intl: { T },
}) => (
  <MediaQuery>
    {({ lg }) => (
      <div className={classes.wrapper}>
        <Row wrap="nowrap" alignItems="center" className={classes.container}>
          <Col className={classes.iconContainer}>
            <CalendarToday color="primary" className={classes.icon} />
          </Col>
          <Col className={classes.textContainer}>
            <Typography variant="subheading" color="primary">
              {!lg && `${T('Hurry up!')} `}
              {T(
                'Most of our listings have already been rented out for these dates.',
              )}
            </Typography>
          </Col>
        </Row>
      </div>
    )}
  </MediaQuery>
);

export default withIntl(withStyles(styles)(SearchUrgencyCard));
